import { Injectable } from '@angular/core';
import apiConfig from './api-client/api-config';
import { ApiRequestService } from './api-client/api-requests.service';
import { Constants } from './utils/Constants';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';
import { TokenService } from './token.service';
import { DrAuthService } from './dr-auth';

@Injectable()
export class CommonService {
  constructor(
    private apiClient: ApiRequestService,
    private cookieService: CookieService,
    private tokenService: TokenService,
    private drAuth: DrAuthService,
  ) { }

  getPresignedUrl(callback) {
    this.apiClient.callApi(Constants.API_METHODS.POST, apiConfig.getPresignedURL.uri, { "uploadtype": "user" }).subscribe((res) => {
      let { data: preSignedData = [] } = res;
      let [data] = preSignedData;
      callback.preSignedCallBack(data);
    })

  }

  
  /**
   * @description It will clear all cookies related onetrust
   * @returns void
   */
  clearCookies() {
    this.cookieService.delete('OptanonConsent', '/');
    this.cookieService.delete('OptanonAlertBoxClosed', '/');
  }

  /**
   * @description get lattest value of Cookies 
   * @returns boolean true | false
   */
  get cookiesEventTrigger() {
    return localStorage.getItem('cookiesEventTrigger');
  }

  /**
   * @description set lattest value of Cookies 
   * @returns boolean true | false
   */
  set cookiesEventTrigger(status: string) {
    localStorage.setItem('cookiesEventTrigger', status);
  }

  /**
   * Stores Cognito tokens for primary and secondary AWS regions in localStorage.
   *
   * This helper is used after multi-region Cognito sign-up or login,
   * saving both primary and secondary tokens in a structured format.
   *
   * LocalStorage Format:
   * - Primary:
   *   CognitoIdentityServiceProvider.{clientId}.{email}.accessToken
   *   CognitoIdentityServiceProvider.{clientId}.{email}.idToken
   *   CognitoIdentityServiceProvider.{clientId}.{email}.refreshToken
   *
   * - Secondary:
   *   CognitoIdentityServiceProvider.{clientIdSecondary}.{email}.secondary.accessToken
   *   CognitoIdentityServiceProvider.{clientIdSecondary}.{email}.secondary.idToken
   *   CognitoIdentityServiceProvider.{clientIdSecondary}.{email}.secondary.refreshToken
   *
   * @param regionTokens Array/Object of region token objects from API response
   * @param email User's email (used in localStorage keys)
   * @param primaryRegion Primary Cognito region name (e.g., 'us-east-1')
   * @param secondaryRegion Secondary Cognito region name (e.g., 'us-west-2')
   * @param clientId Cognito App Client ID for primary region
   * @param clientIdSecondary Cognito App Client ID for secondary region
   */
  storeRegionTokens(regionTokens: any, email: string, isSignUp = true): void {
    if (!email || !regionTokens) return;

    const { region, regionSecondary } = environment;

    let primaryToken, secondaryToken;
    if (isSignUp) {
      primaryToken = regionTokens.find(r => r.region === region);
      secondaryToken = regionTokens.find(r => r.region === regionSecondary);
    }
    else {
      primaryToken = regionTokens[region];
      secondaryToken = regionTokens[regionSecondary];
    }

    this.tokenService.setTokens(primaryToken, secondaryToken, email);
    this.drAuth.init();

  }

  removeTokens(): void {
    this.tokenService.deleteTokens();

  }
}
